import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { getAbout } from "../services";
import { RichText } from "@graphcms/rich-text-react-renderer";

const About = () => {
  const [loading, setLoading] = useState(true);
  const [about, setAbout] = useState([]);
  useEffect(() => {
    getAbout()
      .then((result) => {
        setAbout(result);
        setLoading(false);
      })
      .catch((err) => console.log(err));
  }, []);

  return (
    <div>
      {loading ? (
        <div className="load flex items-center justify-center">
          <div className="w-16 h-16 border-4 border-white border-solid rounded-full animate-spin"></div>
        </div>
      ) : (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <section className="w-full h-full">
            <div className="px-10 lg:px-20 mt-10 pb-10 content-center">
              <h1 className="block text-center capitalized font-bold font-ailerons text-3xl border-b border-b-solid border-b-white pb-5">
                About Me
              </h1>
              <div className="cut mt-10 p-4 lg:py-10 lg:px-12 border border-solid border-white">
                {about && (
                  <React.Fragment>
                    <RichText
                      content={about[0].about.raw.children}
                      renderers={{
                        p: ({ children }) => <p className="mb-8">{children}</p>,
                        ul: ({ children }) => (
                          <ul className="mb-8 grid lg:grid-cols-2">
                            {children}
                          </ul>
                        ),
                        li: ({ children }) => (
                          <li className="mb-3 list-disc list-inside pl-5">
                            {children}
                          </li>
                        ),
                        h3: ({ children }) => (
                          <h3 className="text-xl font-semibold mb-4">
                            {children}
                          </h3>
                        ),
                        h4: ({ children }) => (
                          <h4 className="text-md font-semibold mb-4">
                            {children}
                          </h4>
                        ),
                        a: ({ children, href }) => (
                          <a href={href} target="blank">
                            {children}
                          </a>
                        ),
                      }}
                    />
                  </React.Fragment>
                )}
              </div>
            </div>
          </section>
        </motion.div>
      )}
    </div>
  );
};

export default About;
